import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/GlobalState";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import InviteForm from "./InviteForm";
import { RoleContext } from "../../context/RoleContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouteMatch, withRouter } from "react-router-dom";
import userCalls from "../../services/api/users";
import workspaceCalls from "../../services/api/workspaces";

const UserList = ({ history }) => {
  const [inEditMode, toggleEditMode] = useState(false);
  const { getWorkspaceUsers, users, setSelectedUser } = useContext(RoleContext);
  const { currentWorkspace, userData } = useContext(GlobalContext);
  let { url } = useRouteMatch();

  const handleRoleClick = (user) => {
    if (!user.id) {
      return;
    }
    setSelectedUser(user);
    history.push(`${url}/permissions`);
  };

  const handleDeleteClick = async (user) => {
    if (user.id) {
      try {
        await userCalls.removeFromWorkspace({
          userId: user.id,
          workspaceId: currentWorkspace.id,
        });
        await getWorkspaceUsers();
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        await workspaceCalls.removeInvite({
          workspace: currentWorkspace.id,
          emailAddress: user.emailAddress,
          isAdmin: userData.isAdmin,
        });
        await getWorkspaceUsers();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleEditClick = () => {
    toggleEditMode(!inEditMode);
  };

  let workspaceUsers;
  const getUserList = async () => {
    workspaceUsers = await getWorkspaceUsers();
  };

  useEffect(() => {
    getUserList();
  }, []);
  return (
    <div className={container}>
      <div className="editRow">
        <div
          className={`editItem ${inEditMode && "cancel"}`}
          onClick={() => handleEditClick()}
        >{`${!inEditMode ? "Edit" : "Cancel"}`}</div>
      </div>
      <ul>
        {users.map((user) => {
          if (user.emailAddress === userData.emailAddress) {
            user.isSelf = true;
          }

          return (
            <li key={user.emailAddress}>
              <div
                className={`${
                  inEditMode ? "listItemBody cancelItemActive" : "listItemBody"
                  }`}
              >
                <div className="userRow">
                  <div className="userItem">
                    <div className="userName">
                      {user.firstName} {user.lastName} {user.isSelf && '(me)'}
                    </div>
                    <div className="email">{user.emailAddress}</div>
                  </div>
                  <div
                    className={`role ${(!user.id || user.isSelf) && "disabled"}`}
                    onClick={!user.isSelf ? () => handleRoleClick(user) : () => {}}
                  >
                    {user.role}{" "}
                    {!user.isSelf && <span>
                    {user.id && (
                      <FontAwesomeIcon className="icon" icon="chevron-right" />
                    )}
                  </span>}
                  </div>
                </div>
                <div className={`cancelItem ${(inEditMode && !user.isSelf) && "cancelItemActive"}`}>
                  <div
                    className="removeX"
                    onClick={!user.isSelf ? () => handleDeleteClick(user) : () => {}}
                  >
                    <FontAwesomeIcon className="removeBtn" icon="times" />
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <InviteForm />
    </div>
  );
};

export default withRouter(UserList);

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 0 25px 0;

  .editRow {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: ${boxStyles.desktopPadding};

    .editItem {
      cursor: pointer;
      transition-duration: 1s;

      @media screen and (min-width: ${boxStyles.desktopBreak}) {
        width: 10;
        &:hover {
          color: red;
        }
      }
    }
  }

  .removeX {
    cursor: pointer;
  }

  .cancelItem {
    display: flex;
    justify-content: flex-end;
    transition-duration: 1s;
    width: 0%;
    overflow: hidden;
  }

  .cancelItemActive {
    width: 5%;
    color: red;
    padding: 0 0 0 10px;

    @media screen and (max-width: ${boxStyles.desktopBreak}) {
      width: 10%;
    }
  }

  .listItemBody {
    display: flex;
    flex-direction: row;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid ${colors.lineBreak};
    padding: ${boxStyles.standardPadding} 40px;
    align-items: center;
    justify-content: space-between;

    .userRow {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      transition-duration: 1s;
    }
  }
  
  .fa-chevron-right {
    margin-left: 3px;
    transform: rotate(90deg);
  }

  ul {
    display: flex;
    flex-direction: column;
    list-style-type: none;
    padding: 0;
    margin: 0;
    width: 100%;
    
    li:first-child {
      border-top: 1px solid ${colors.lineBreak};
    }
  }
  .userItem {
    display: flex;
    flex-direction: column;
  }

  .userName {
    font-weight: 500;
    font-size: ${textSizes.intermediate};
    color: ${colors.titleColor};
  }
  .email {
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
  }

  .role {
    display: flex;
    align-items: center;
    text-transform: capitalize;
    font-size: ${textSizes.normal};
    color: ${colors.titleColor};
    text-decoration: none;
    transition-duration: 400ms;
    cursor: pointer;

    &:hover {
      color: ${colors.brandColor};
    }
    span {
      padding: 0 4px;
    }
  }

  .disabled {
    color: ${colors.placeholderText};
    cursor: default;

    &:hover {
      cursor: default;
      color: ${colors.placeholderText};
    }
  }
`;
